export enum CRMItemEnum {
   CONTACT = 'CONTACT',
   LEAD = 'LEAD',
   DEAL = 'DEAL',
   TASK = 'TASK',
   ACTIVITY = 'ACTIVITY',
   PIPELINE_EVENT = 'PIPELINE_EVENT',
   CUSTOM_OBJECT = 'CUSTOM_OBJECT',
   APPLICATION = 'APPLICATION'
}

export enum LayoutTabTaskStatusEnum {
   NotStarted = 'NOT_STARTED',
   RequiredFieldsNotFilled = 'REQUIRED_FIELDS_NOT_FILLED',
   OverallRemarksNotFilled = 'OVERALL_REMARKS_NOT_FILLED',
   Accepted = 'ACCEPTED',
   Rejected = 'REJECTED',
   Shortfall = 'SHORTFALL',
   FieldRemarksNotFilled = 'FIELD_REMARKS_NOT_FILLED',
   Discarded = 'DISCARDED'
}
